import { render, staticRenderFns } from "./EventCreate.vue?vue&type=template&id=7972511e&"
import script from "./EventCreate.vue?vue&type=script&lang=js&"
export * from "./EventCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports